import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DialogModule, TooltipModule } from "primeng/primeng";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";

import { NgAppDeployComponent, TCITenantMiniDetailsDynLoaderComponent } from "./ng-app-deploy.component";
import { NgDeployConfirmationDialogIsAliveComponent } from "./dialog-confirmation-isAlive/dialog-confirmation-isAlive.component";
import { NgAppDeployService } from "./ng-app-deploy.service";

import { NgClickOutsideModule } from "../ng-shared/ng-directives/ng-click-outside/ng-click-outside.module";
import { NgWaitModule } from "../ng-shared/ng-components/ng-wait/ng-wait.module";
import { NgOnlyNumberModule } from "../ng-shared/ng-directives/ng-only-number/ng-only-number.module";

function NgAppDeployServiceFactory(): NgAppDeployService {
    return NgAppDeployService.getInstance();
}

@Pipe({ name: "safeHtml" })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgWaitModule,
        NgOnlyNumberModule,
        NgClickOutsideModule,
        TooltipModule,
        PerfectScrollbarModule,
        DialogModule
    ],
    declarations: [
        NgAppDeployComponent,
        TCITenantMiniDetailsDynLoaderComponent,
        NgDeployConfirmationDialogIsAliveComponent,
        SafeHtmlPipe
    ],
    providers: [
        {
            provide: NgAppDeployService,
            useFactory: NgAppDeployServiceFactory,
            deps: []
        }
    ],
    exports: [
        NgAppDeployComponent,
        NgDeployConfirmationDialogIsAliveComponent
    ]
})
export class NgAppDeployModule {
}
